import React from 'react';
class LoomIntegrationComponent extends React.PureComponent {
    render(){
        return <div dangerouslySetInnerHTML={{ __html: "<div style='position: relative; padding-bottom: 62.5%; height: 0;'><iframe src='https://www.loom.com/embed/2b3e41b008a248f58baff64895c308b4?autoplay=1' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen style='position: absolute; top: 0; left: 0; width: 100%; height: 100%;'></iframe></div>" }} />
    }
}

export default LoomIntegrationComponent;